<template>
  <div :class="componentClassName">
    <div class="o-sf-incoming-call-modal__button">
      <a-button
        id="incomingCall"
        variant="icon"
        color="primary"
        icon="phone-incoming-call"
        icon-color="white"
        @click="handleToggleClick"
      />
      <i v-if="hasNewCall || hasNewOnHold" class="o-sf-incoming-call-modal__indicator-new-call" />
    </div>
    <div v-show="isExpanded" class="o-sf-incoming-call-modal__popup">
      <div class="o-sf-incoming-call-modal__popup-tab-holder">
        <i v-if="hasNewOnHold" class="o-sf-incoming-call-modal__indicator-new-onhold" />
        <m-tab class="o-sf-incoming-call-modal__popup-tab" @change="handleTabChange">
          <a-tab-pane label="着信" name="tab-incoming-call" class="o-sf-incoming-call-modal__incoming-tab">
            <div v-if="!customerInfo" class="o-sf-incoming-call-modal__call-empty">着信はありません</div>
            <a-calling-customer-info
              v-if="customerInfo"
              :title="customerInfo.title"
              :phone-number="customerInfo.phoneNumber"
              :subtitle="customerInfo.subtitle"
              :call-is-incomming="true"
            />
            <div v-if="telNumberInfo || pushNumberSettingName" class="o-sf-incoming-call-modal__response-status">
              <a-calling-response-status v-if="myInfoList.length" :status-list="myInfoList" />
            </div>
            <div v-if="customerInfo" class="o-sf-incoming-call-modal__call-actions">
              <a-button
                variant="icon"
                color="primary-red"
                icon="phone-reject-call"
                icon-color="white"
                @click="handleRejectCallClickAndToggle"
              />
              <a-button
                variant="icon"
                color="green"
                icon="phone-receive-call"
                icon-color="white"
                @click="
                  handleReceiveCallClick();
                  closeExpandedModal();
                "
              />
            </div>
          </a-tab-pane>
          <a-tab-pane label="保留" name="tab-on-hold" class="o-sf-incoming-call-modal__onhold-tab">
            <ul v-if="onholdList.length > 0" class="o-sf-incoming-call-modal__onhold-list">
              <li v-for="(item, index) in onholdList" :key="index" :class="getOnHoldButtonClassName(item)">
                <a-button
                  variant="icon"
                  icon="phone-call-onhold"
                  :icon-color="item.active ? 'orange' : 'grey'"
                  :disabled="!item.active"
                  @click="handleOnholdButtonClick(item.id)"
                />
                <span class="o-sf-incoming-call-modal__onhold-button-label">取次保留 {{ index + 1 }}</span>
              </li>
            </ul>
            <div v-else class="o-sf-incoming-call-modal__onhold-empty">着信はありません</div>
          </a-tab-pane>
        </m-tab>
      </div>
    </div>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import MTab from '@/components/molecules/tab';
import ATabPane from '@/components/atoms/tab-pane';
import AButton from '@/components/atoms/button';
import ACallingCustomerInfo from '@/components/atoms/calling-customer-info';
import ACallingResponseStatus from '@/components/atoms/calling-response-status';
import { customRequest } from '@/common/customRequest.js';
import Loading from 'vue-loading-overlay';
import { utils } from '@/common/utils.js';

export default {
  name: 'o-sf-incoming-call-modal',
  components: {
    MTab,
    ATabPane,
    AButton,
    ACallingCustomerInfo,
    ACallingResponseStatus,
  },
  mixins: [customRequest, utils],
  props: {
    class: {
      type: String,
      default: '',
    },
    customerInfo: {
      type: Object,
      default: null,
    },
    responseStatusList: {
      type: Array,
      default: new Array(0),
    },
    onholdList: {
      type: Array,
      default: new Array(0),
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    activeTab: {
      type: String,
      default: null,
    },
    handleIncomingCallTabChange: {
      type: Function,
      default: () => {},
    },
    handleRejectCallClick: {
      type: Function,
      default: () => {},
    },
    handleReceiveCallClick: {
      type: Function,
      default: () => {},
    },
    handleOnholdButtonClick: {
      type: Function,
      default: () => {},
    },
    // indicator
    hasNewCall: {
      type: Boolean,
      default: false,
    },
    hasNewOnHold: {
      type: Boolean,
      default: false,
    },
    sfCases: {
      type: Object,
      default: null,
    },
    sfContactInfo: {
      type: Object,
      default: null,
    },
    pushNumberSettingName: {
      type: String,
      default: '',
    },
    telNumberInfo: {
      type: Object,
      default: null,
    },
  },
  emits: ['modal:displayed'],
  data() {
    return {
      isExpanded: false,
      currentTab: null,
      isExistSfCases: false,
      isSfLoading: true,
      isSfHover: false,
      isSfClick: false,
      sfContactName: '',
      sfContactAvailable: false,
      sfTable: null,
      sfAvailable: false,
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('o-sf-incoming-call-modal');
      return `${baseClassName} ${this.class}`.trim();
    },
    hoverClickColor() {
      if (this.isSfHover && this.isSfClick) {
        return 'o-sf-incoming-call-modal__sfinfo__hoverclick';
      } else if (this.isSfHover) {
        return 'o-sf-incoming-call-modal__sfinfo__hover';
      } else {
        return '';
      }
    },
    myInfoList() {
      const ret = [];
      if (!this.telNumberInfo && !this.pushNumberSettingName) return ret;

      if (this.telNumberInfo.numberName) {
        ret.push({ label: '番号名称', value: this.collapseText(this.telNumberInfo.numberName, 10) });
      }
      if (this.telNumberInfo.telNumber) {
        ret.push({ label: '自番号', value: this.telNumberInfo.telNumber });
      }

      if (this.pushNumberSettingName) {
        ret.push({ label: 'プッシュ番号', value: this.collapseText(this.pushNumberSettingName, 10) });
      }
      return ret;
    },
  },
  watch: {
    expanded(val) {
      this.isExpanded = val;
    },
    activeTab(val) {
      this.currentTab = val;
    },
    sfCases(val) {
      if (val) {
        this.initSfCases();
      }
    },
    sfContactInfo(val) {
      if (val) {
        if (val.length > 0) {
          this.sfContactName = this.sfContactInfo[0].Name;
        } else {
          this.sfContactName = '<取引先責任者未登録>';
        }
        this.isSfLoading = false;
      }
    },
    customerInfo(val) {
      if (!val) {
        this.isExistSfCases = false;
      } else {
        this.setSoftphonePanelVisibility();
        this.searchAndScreenPop();
      }
    },
  },
  async mounted() {
    if (this.expanded) {
      this.isExpanded = this.expanded;
    }
    if (this.activeTab) {
      this.currentTab = this.activeTab;
    }
    this.initSfCases();
    await this.postRequest('/callLogClient/getSfPopupAvailable', {})
      .then(e => {
        if (e.status === 'success') {
          this.sfContactAvailable = e.data.companyInfo.sfContactAvailable;
          this.sfTable = e.data.companyInfo.sfTable;
          this.sfAvailable = e.data.companyInfo.sfAvailable;
        }
      })
      .catch(err => {
        console.error(err);
      });
  },
  methods: {
    handleToggleClick() {
      this.isExpanded = !this.isExpanded;
      this.$emit('modal:displayed', this.isExpanded);
    },
    handleTabChange(tab) {
      this.currentTab = tab;
      this.handleIncomingCallTabChange(tab);
    },
    getOnHoldButtonClassName(item) {
      const className = mapModifiers('o-sf-incoming-call-modal__onhold-button', item.active ? 'active' : 'disabled');
      return className;
    },
    handleRejectCallClickAndToggle() {
      this.handleRejectCallClick();
      this.handleToggleClick();
    },
    initSfCases() {
      if (this.sfCases) {
        this.isExistSfCases = true;
        for (const sfCase of this.sfCases) {
          const createdDateObj = new Date(sfCase.sfCreatedDate);
          if (Number.isNaN(createdDateObj.getTime())) {
            sfCase.CreatedDateStr = '';
          } else {
            const createdDateStr = createdDateObj.toLocaleDateString('ja-JP', { timeZone: 'Asia/Tokyo' });
            const createdTimeStr = createdDateObj.toLocaleTimeString('ja-JP', { timeZone: 'Asia/Tokyo' });
            sfCase.CreatedDateStr = createdDateStr + ' ' + createdTimeStr;
          }
        }
      }
    },
    mouseOverAction() {
      this.isSfHover = true;
    },
    mouseLeaveAction() {
      this.isSfHover = false;
    },
    handleDescriptionClick() {
      this.isSfClick = !this.isSfClick;
      if (!this.isSfClick) {
        this.isSfHover = false;
      }
    },
    setSoftphonePanelVisibility() {
      const sendData = {
        message: 'setSoftphonePanelVisibility',
        data: {},
      };
      window.parent.postMessage(JSON.stringify(sendData), '*');
    },
    searchAndScreenPop() {
      if (this.customerInfo.phoneNumber) {
        const sendData = {
          message: 'searchAndScreenPop',
          data: {
            phoneNumber: this.customerInfo.phoneNumber,
          },
        };
        window.parent.postMessage(JSON.stringify(sendData), '*');
      }
    },
    closeExpandedModal() {
      if (this.isExpanded) {
        this.isExpanded = !this.isExpanded;
      }
    },
  },
};
</script>
